export const requestors = {
  form: {
    chooseOption: 'Choose an option',
    fields: {
      email: {
        label: 'Email',
      },
      firstName: {
        label: 'First Name',
      },
      lastName: {
        label: 'Last Name',
      },
      paymentMethodInstruction: {
        label: 'Payment Method',
        options: {
          current: 'Use your current payment method: %paymentMethod%',
          createNew: 'Require them to create a separate payment method',
        }
      },
      phone: {
        label: 'Phone Number',
      },
      role: {
        label: 'User Role',
        options: {
          admin: 'Admin - can see and manage all jobs, can add/remove other users',
          manager: 'Manager - can see and manage jobs they create or which are assigned to them, cannot add/remove other users',
          read_only: 'Read Only - can see jobs assigned to them and perform basic management options on them (e.g. rate), cannot post jobs',
        },
      },
      title: {
        label: 'Title',
      },
      budget: {
        label: 'Budget',
      },
      avatar: {
        cropImageModal: {
          title: 'Crop Image',
          submit: 'Set as Avatar',
        },
      },
      password: {
        label: 'New Password',
      },
      passwordConfirmation: {
        label: 'Password Confirmation',
      }
    },
    messages: {
      createRequestorSuccess: '%firstName% %lastName% profile has been created.',
      updateRequestorSuccess: '%firstName% %lastName% profile has been updated.',
    },
    sections: {
      requestorInfo: {
        title: 'Requestor Info',
      },
      addImages: {
        title: 'Add/Edit images',
        description: '- %maxWidth% x %maxHeight% pixels, png or jpg format, 2MB max.',
      },
      changePassword: {
        title: 'Change Password',
      },
    },
    validations: {
      required: '%fieldLabel% is required',
      invalidEmail: 'Incorrect format. Follow this example: yourname@example.com',
      passwordTooShort: 'Password is too short (minimum is 8 characters)',
      passwordFormat: 'Password requires one uppercase letter, one lowercase letter, and one number',
      passwordSpace: 'Password cannot contain spaces',
    },
    unsavedChangesConfirmation: 'You have made changes. Do you want to discard or save them?',
  }
};
